export default __webpack_public_path__ + "static/media/league-family-education-banner_lf-education.84c9138a.png";